<template>
  <div class="  border-top py-3 mt-1">
    <div class="d-flex ">
      <div class="w-100">
        <div class="d-flex">
          <div class="mb-2">
            {{ data.content.Text.Text }}
          </div>
        </div>

        <div
          v-for="(item, index) in data.content.Button"
          :key="index"
          class="d-flex w-100"
        >
          <div class="d-flex w-100">
            <div
              @click="$emit('openNextFlowListFromButton', level, item)"
              class="d-flex p-2 w-100 my-1 bg-button"
              :class="[
                {
                  'bg-button-focus': flowActiveIds.includes(
                    item.IntentHierarchyId
                  )
                }
              ]"
            >
              <div class="my-auto">
                <font-awesome-icon icon="circle" class="fa-w-10" />
              </div>
              <div class="ml-2 my-auto">
                {{ item.Label }}
              </div>
            </div>
            <div class="m-auto">
              <b-dropdown
                size="lg"
                variant="link"
                toggle-class="text-decoration-none text-gray p-0 pl-2"
                no-caret
              >
                <template #button-content>
                  <font-awesome-icon icon="ellipsis-v" class="mt-2 pointer" />
                </template>
                <b-dropdown-item-button
                  v-if="item.IntentHierarchyId == 0"
                  @click="$emit('createOrUpdateChildIntent', item, data)"
                  >Create next level</b-dropdown-item-button
                >
                <b-dropdown-item-button @click="$emit('updateIntent')"
                  >Edit This Intent</b-dropdown-item-button
                >
                <b-dropdown-item-button
                  @click="$emit('openDeleteButtonModal', item)"
                  >Remove</b-dropdown-item-button
                >
              </b-dropdown>
            </div>
          </div>
        </div>

        <div>
          <div
            class="panel-bg-file-img mr-1 mb-1 mt-2"
            v-bind:style="{
              backgroundImage: 'url(' + data.content.Image.ImageUrl + ')'
            }"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: {
      required: true,
      type: Object
    },
    dataLength: {
      required: true,
      type: Number
    },
    flowActiveIds: {
      required: true,
      type: Array
    },
    level: {
      required: true,
      type: Number
    },
    channelList: {
      required: true,
      type: Array
    }
  },
  computed: {
    channelType: function() {
      return this.channelList.find(el => {
        return el.id == this.data.channelTypeId;
      });
    }
  },
  methods: {
    handleClick() {
      this.$refs.sidebarIntent.show();
    }
  }
};
</script>

<style lang="scss" scoped>
.rounded-circle,
.rounded-circle:hover,
.rounded-circle:active,
.rounded-circle:focus {
  border-radius: 50%;
  height: 37px;
  width: 37px;
  padding-top: 8px !important;
  background-color: #242424;
  //  color: #242424;
}
.bg-button {
  background-color: #e2dff3;
  color: #7160c4;
  border-color: #e2dff3;
  font-size: 14px;
  border-radius: 5px;
}
.bg-button-focus {
  background-color: #7d6da8;
  color: white;
  font-size: 14px;
}
.panel-bg-file-img {
  position: relative;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border: 2px dashed #bebebe;
  border-radius: 6px;
  width: 100px;
  height: 100px;
  cursor: pointer;
}
</style>
